import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, SlidersHorizontal, X } from "lucide-react";
import useCookieConsent from "../hooks/useCookieConsent";
import { COOKIE_CONSENT, OPEN_PRIVACY_SETTINGS_EVENT, setCookieConsent } from "../util/privacyConsent";

export default function CookieConsentBanner() {
  const choice = useCookieConsent();
  const [open, setOpen] = useState(() => !choice);
  const headingRef = useRef(null);
  useEffect(() => { setOpen(!choice); }, [choice]);
  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(OPEN_PRIVACY_SETTINGS_EVENT, show);
    return () => window.removeEventListener(OPEN_PRIVACY_SETTINGS_EVENT, show);
  }, []);
  useEffect(() => {
    if (!open || !choice) return;
    headingRef.current?.focus();
    const dismiss = (event) => { if (event.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", dismiss);
    return () => window.removeEventListener("keydown", dismiss);
  }, [open, choice]);
  const choose = (value) => { setCookieConsent(value); setOpen(false); };
  return (
    <>
      {!open && <button type="button" onClick={() => setOpen(true)} className="privacy-trigger" aria-label="Privacy settings" aria-expanded={false}>
        <SlidersHorizontal size={16} aria-hidden="true" /><span>Privacy settings</span>
      </button>}
      {open && <section className="privacy-banner" aria-labelledby="privacy-title">
        <div className="privacy-banner-inner">
          <div className="privacy-copy">
            <Cookie size={24} className="shrink-0 text-brand-cherry" aria-hidden="true" />
            <div>
              <h2 id="privacy-title" ref={headingRef} tabIndex={-1} className="font-semibold text-slate-950 outline-none">Your shopping, your choice.</h2>
              <p>Allow us to remember your searches and product views for suggestions that suit you. Necessary cookies keep sign-in, your cart, and checkout working either way.</p>
              <Link to="/cookies-policy">Cookie policy</Link><span className="px-2" aria-hidden="true">·</span><Link to="/privacy-policy">Privacy policy</Link>
              {choice && <span className="ml-3 text-slate-500">{choice === COOKIE_CONSENT.ACCEPTED ? "Personalization on" : "Necessary only"}</span>}
            </div>
          </div>
          <div className="privacy-actions">
            <button type="button" className="store-button store-button-outline" onClick={() => choose(COOKIE_CONSENT.DENIED)}>Necessary only</button>
            <button type="button" className="store-button store-button-primary" onClick={() => choose(COOKIE_CONSENT.ACCEPTED)}>Allow personalization</button>
            {choice && <button type="button" aria-label="Close privacy settings" onClick={() => setOpen(false)} className="privacy-close"><X size={20} /></button>}
          </div>
        </div>
      </section>}
    </>
  );
}

